export enum ClubEnum {
    Code=1,
    UseCredit = 2,
    Mobile = 3,
    SupportNumber = 4
}